import { Dialog } from "primereact/dialog";
import { useState } from "react";
import { Trans } from "react-i18next";
import Ifu from "./ifu";
import HardCopyRequest from "./hardCopyRequest";

const AboutUs = ({ t, aboutUsdialogVisible, setAboutUsdialogVisible, isLoggedIn = false }: any) => {
    const [ifuDialogVisible, setIfuDialogVisible] = useState(false);
    const [hardCopyDialogVisible, setHardCopyDialogVisible] = useState(false);

    return (
        <>
            <Dialog
                header={t("aboutUsHeader")}
                visible={aboutUsdialogVisible}
                draggable={false}
                style={{ width: '80vw', borderRadius: '24px', overflow: "hidden" }}
                onHide={() => setAboutUsdialogVisible(false)} blockScroll>

                <p className="m-0 text-md" style={{ color: "#727A99" }}>{t("aboutUsDescription")}</p>

                <br />

                <div className="flex align-items-start justify-content-between gap-4 w-full">
                    <div className="flex flex-column  w-full">
                        <div className="flex align-items-center gap-2">
                            <div style={{ width: "7rem", height: "7rem" }} className="flex align-items-center justify-content-center">
                                <img src="/mdIcon.png" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                            </div>
                            <div className="flex flex-column w-full">
                                <p className="text-lg m-0 font-bold" style={{ color: "#2D3967" }}> {t("medicalDevice")}</p>
                                <p className="m-0 text-md" style={{ color: "#727A99" }}>{t("mobitheraClassified")}</p>
                            </div>
                        </div>
                        <div className="flex align-items-center gap-2">
                            <div style={{ width: "7rem", height: "7rem" }} className="flex align-items-center justify-content-center">
                                <img src="/companyIcon.png" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                            </div>
                            <div className="flex flex-column w-full">
                                <p className="text-lg m-0 font-bold" style={{ color: "#2D3967" }}> {t("mobitheraCompany")}</p>
                                <p className="m-0 text-md" style={{ color: "#727A99" }}>{t("address")}</p>
                            </div>
                        </div>

                        <div className="flex align-items-center gap-2">
                            <div style={{ width: "7rem", height: "7rem" }} className="flex align-items-center justify-content-center">
                                <img src="/udiIcon.png" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                            </div>

                            <div className="flex align-items-center w-full gap-2">
                                <div style={{ width: "3.6rem", height: "5rem" }} className="flex align-items-center justify-content-center">
                                    <img src="/barcode420.jpg" style={{ width: "100%", height: "100%", objectFit: "contain", marginTop: "0.2rem" }} />
                                </div>
                                <p className="m-0 text-md" style={{ color: "#727A99" }}>(01)08684917043125 <br />(8012)4.2.0</p>
                            </div>
                        </div>

                        <div className="flex align-items-center gap-2">
                            <div style={{ width: "7rem", height: "7rem" }} className="flex align-items-center justify-content-center">
                                <img src="/refIcon.png" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                            </div>
                            <div className="flex flex-column w-full">
                                <p className="text-lg m-0 font-bold" style={{ color: "#2D3967" }}> MOB.03</p>
                                <p className="m-0 text-md" style={{ color: "#727A99" }}>{t("MobitheraWebApplication")}</p>
                            </div>
                        </div>

                    </div>


                    <div className="flex flex-column gap-2 w-full">
                        <div className="flex align-items-center gap-1">
                            <div style={{ width: "7rem", height: "7rem" }} className="flex align-items-center justify-content-center">
                                <img src="/instructionsIcon.png" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                            </div>
                            <div className="flex flex-column w-full">
                                <p className="text-lg m-0 font-bold" style={{ color: "#2D3967" }}> {t("clickForUserManual")}</p>
                            <p className="m-0 text-md" style={{ color: "#727A99" }}>
                                <Trans
                                    i18nKey="downloadInstructions"
                                    components={{
                                        clickable: (
                                            <span
                                                onClick={() => {
                                                    setAboutUsdialogVisible(false);
                                                    setIfuDialogVisible(true);
                                                }}
                                                className="cursor-pointer text-blue-500"
                                            />
                                        ),
                                    }}
                                />
                            </p>
                            </div>
                        </div>

                        <div className="flex align-items-center gap-1">
                            <div style={{ width: "7rem", height: "7rem" }} className="flex align-items-center justify-content-center">
                                <img src="/instructionsIcon.png" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                            </div>
                            <div className="flex flex-column w-full">
                                <p className="text-lg m-0 font-bold" style={{ color: "#2D3967" }}> {t("hardCopy")}</p>
                            <p className="m-0 text-md" style={{ color: "#727A99" }}>
                                <Trans
                                    i18nKey="hardCopyDescription"
                                    components={{
                                        clickable: (
                                            <span
                                                onClick={() => {
                                                    setAboutUsdialogVisible(false);
                                                    isLoggedIn ? setHardCopyDialogVisible(true) : setIfuDialogVisible(true);
                                                }}
                                                className="cursor-pointer text-blue-500"
                                            />
                                        ),
                                    }}
                                />
                            </p>
                            </div>
                        </div>

                        <div className="flex align-items-center">
                            <div style={{ width: "7rem", height: "7rem" }} className="flex align-items-center justify-content-center">
                                <img src="/ce-mark.jpeg" style={{ width: "100%", height: "100%", objectFit: "contain", marginRight: "1rem" }} />
                            </div>
                        </div>

                        <div className="flex align-items-center">
                            <div className="flex flex-column w-full  mt-2">
                                <p className="text-md m-0 font-bold" style={{ color: "#2D3967" }}> {t("softwareVersion")}: <span className="font-normal" style={{ color: "#727A99" }}>4.2.0</span></p>
                                <p className="m-0 text-md font-bold" style={{ color: "#2D3967" }}>{t("versionReleaseDate")}: <span className="font-normal" style={{ color: "#727A99" }}>2026-10-23</span></p>

                            </div>
                        </div>

                        <div className="flex align-items-center justify-content-end mt-auto">

                            <div className="flex flex-column">
                                <p className="m-0 text-md " style={{ color: "#2D3967" }}>LB.01</p>
                                <p className="m-0 text-md " style={{ color: "#2D3967" }}>
                                    {t("publishDate")}: 27.12.2024
                                </p>
                                <p className="m-0 text-md " style={{ color: "#2D3967" }}>
                                    {t("revisionNo")}: 02
                                </p>
                                <p className="m-0 text-md " style={{ color: "#2D3967" }}>
                                    {t("revisionDate")}: 23.10.2026
                                </p>
                            </div>

                        </div>
                    </div>

                </div>
            </Dialog>

            <Ifu 
                ifuDialogVisible={ifuDialogVisible}
                setIfuDialogVisible={setIfuDialogVisible}
            />

            <HardCopyRequest
                hardCopyDialogVisible={hardCopyDialogVisible}
                setHardCopyDialogVisible={setHardCopyDialogVisible}
            />
        </>
    )
}


export default AboutUs